import type { LoanStatus } from '@/types';

export const LOAN_STATUS_GUIDANCE: Record<LoanStatus, { description: string; nextStep: string }> = {
  APPLICATION: {
    description: 'The loan is being prepared and has not been submitted for assessment.',
    nextStep: 'Complete the application details, then submit it for review.',
  },
  UNDER_REVIEW: {
    description: 'The application is awaiting an assessment by an authorised officer or manager.',
    nextStep: 'Review the application, supporting documents, and credit decision.',
  },
  APPROVED: {
    description: 'The loan has been approved and is ready for funding arrangements.',
    nextStep: 'Confirm all conditions are met before recording disbursement.',
  },
  DISBURSED: {
    description: 'Funds have been released to the borrower and the loan is moving into servicing.',
    nextStep: 'Confirm the repayment schedule and monitor the first payment.',
  },
  CURRENT: {
    description: 'The loan is active and up to date with its repayment obligations.',
    nextStep: 'Continue monitoring payments, conditions, and upcoming reviews.',
  },
  DELINQUENT_30: {
    description:
      'A repayment is overdue by at least 30 days and requires early collections action.',
    nextStep: 'Contact the borrower and record the agreed collections action.',
  },
  DELINQUENT_60: {
    description: 'The repayment delinquency has reached 60 days and requires escalated follow-up.',
    nextStep: 'Escalate collections and assess whether additional recovery action is required.',
  },
  DELINQUENT_90: {
    description: 'The loan is seriously delinquent at 90 days overdue.',
    nextStep: 'Complete the default assessment or agree a formal restructure.',
  },
  DEFAULT: {
    description: 'The loan is formally in default and default interest or enforcement may apply.',
    nextStep: 'Follow the documented recovery and enforcement process.',
  },
  PAID_OFF: {
    description: 'The loan has been fully repaid and no outstanding balance remains.',
    nextStep: 'Complete discharge and archive the loan records.',
  },
  RESTRUCTURED: {
    description: 'The loan terms have been changed under an approved restructure arrangement.',
    nextStep: 'Confirm the new terms, schedule, and borrower communications are complete.',
  },
  CANCELLED: {
    description: 'The loan will not proceed and no further funding activity should occur.',
    nextStep: 'Record the reason and ensure any related workflow items are closed.',
  },
};
